import { useState } from "react"
import MasterPasswordPopup from "../../MasterPasswordPopup";
import { Button } from "react-bootstrap";
import ResetMaterPasswordPopup from "../../ResetMaterPassword/Index";
import { post } from "../../../helpers/api_helper";
import { useSelector } from "react-redux";
import Toast from "react-hot-toast";

const UnlockSection = () => {
  const { email } = useSelector(state => state.login.userData)
  const [showPopup, setShowPopup] = useState(true);
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(15);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [sendOtpLoading, setSendOtpLoading] = useState(false);

  const handleClickResetPwd = async () => {
    try {
      await sendOtp();
      setShowPopup(false);
      setShowResetPopup(true);
    } catch(err) {
      console.error("Error sending master pwd reset otp", err);
    }
  }

  const sendOtp = async () => {
    try {
      setSendOtpLoading(true);
      const response = await post("/user/forgot/password", { email: email });
      if (response?.success) {
        setOtpSent(true);
        setIsTimerActive(true);
        setTimer(15);
      }
      setSendOtpLoading(false);
    } catch (error) {
      setSendOtpLoading(false);
      throw error;
    }
  };

  const resetPasswordCallback = () => {
    setShowResetPopup(false);
    setShowPopup(true);
  }

  return (
    <div className="unlock-section h-100 d-flex justify-content-center align-items-center text-center">
      {showPopup && 
        <MasterPasswordPopup
          showModal={showPopup}
          setShowModal={setShowPopup}
          onClickReset={handleClickResetPwd}
          sendOtpLoading={sendOtpLoading}
        />
      }

      {showResetPopup && 
        <ResetMaterPasswordPopup
          showModal={showResetPopup}
          setShowModal={setShowResetPopup}
          otpSent={otpSent}
          timer={timer}
          setTimer={setTimer}
          isTimerActive={isTimerActive}
          setIsTimerActive={setIsTimerActive}
          resetCallback={resetPasswordCallback}
        />
      }
      <div>
        <p>This section is currently locked.</p>
        <Button
          className="commonBtn btn btn-primary"
          onClick={() => {
            setShowPopup(true);
          }}
        >
          Unlock
        </Button>
      </div>
    </div>
  )
}

export default UnlockSection;